import { render, staticRenderFns } from "./ElInput.vue?vue&type=template&id=c96d3d8a&scoped=true"
import script from "./ElInput.vue?vue&type=script&lang=js"
export * from "./ElInput.vue?vue&type=script&lang=js"
import style0 from "./ElInput.vue?vue&type=style&index=0&id=c96d3d8a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c96d3d8a",
  null
  
)

export default component.exports